import { DirectSubscriptionServices } from '@/services/modules/direct-subscription.service'
import store from '@/store'
import { Action, Module, VuexModule } from 'vuex-module-decorators'

@Module
export default class DirectSubscriptionStore extends VuexModule {
    @Action
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createDirectSubscription (params: any) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve('')
                return
            }
            const data = Object.assign({}, params)
            DirectSubscriptionServices.createDirectSubscription(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
